import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { GuideHead } from './GuideHead';
import { mailboxGuideMessages as messages } from './mailboxGuideMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the guide; each part uses its own slice of it */
import styles from './MailboxGuide.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * Step 3 of 3 while the server checks (design outreach-v2 o6): the servers, the IMAP sign-in, the
 * SMTP sign-in. The check is one call, so the last two rows run until it answers.
 */
const CheckProgressComponent: React.FC = () => {
  const intl = useIntl();
  const row = (label: string, done: boolean) => (
    <div className={clsx(styles.check, !done && styles.checkRun)}>
      <span className={styles.checkIcon}>{done ? <FontAwesomeIcon icon={faCheck} /> : '…'}</span>
      {label}
    </div>
  );
  return (
    <>
      <GuideHead step={3} title={intl.formatMessage(messages.checkingTitle)} />
      <div className={styles.body} data-testid="mailbox-checking">
        <div className={styles.checks}>
          {row(intl.formatMessage(messages.checkFound), true)}
          {row(intl.formatMessage(messages.checkRead), false)}
          {row(intl.formatMessage(messages.checkSend), false)}
        </div>
        <p className="small text-body-secondary mb-0">{intl.formatMessage(messages.checkNote)}</p>
      </div>
    </>
  );
};

export const CheckProgress = TypedMemo(CheckProgressComponent);
